export const PRODUCT_BY_PAGE = 25;
